import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, Signal } from '@angular/core';
import { AuthenticationFacade, UserService } from '@ebeihilfe/core';
import { LogoSvgComponent } from '@ebeihilfe/web-shared/web-svgs/logo/logo.component';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { PortalToolbarComponent } from '../portal-toolbar/portal-toolbar.component';

@Component({
  imports: [AsyncPipe, LogoSvgComponent, PortalToolbarComponent, TranslateModule],
  selector: 'portal-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  private readonly authFacade: AuthenticationFacade = inject(AuthenticationFacade);
  private readonly user: UserService = inject(UserService);

  public isAuthenticated: Observable<boolean>;
  public personalNumber: Signal<string>;

  public ngOnInit(): void {
    this.isAuthenticated = this.authFacade.authenticationChange$;
    this.personalNumber = this.user.username;
  }
}
